import React, { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import Box from "@material-ui/core/Box";
import Fab from "@material-ui/core/Fab";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";

import {
  // AWS_S3,
  LOCATION_MEDIA_GET_LIST_URL,
  LOCATION_MEDIA_CREATE_URL,
  LOCATION_MEDIA_SWAP_URL,
  LOCATION_MEDIA_LAST_SEQUENCE_URL,
  LOCATION_MEDIA_EDIT_URL,
  LOCATION_MEDIA_DELETE_URL
} from "../../config";
import UploadMediaModal from "../media/UploadMediaModal";
import { showSuccessAlert, showErrorAlert } from "../../store/actions/alerts";
import ConfirmDialog from "../dialog/ConfirmDialog";
import MediaEditForm from "../media/MediaEditForm";
import MediaCard from "../media/MediaCard";

import makeApiRequest from "../../utils/axios/new-axios";
import { permissions, types, checkAcl } from "../../utils/acl";

const useStyles = makeStyles(theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
}));

//function has to be defined outside to use inside the useEffect to prevent rendering multiple times
function createMediaCall(locationId, medias, createdBy) {
  return new Promise((resolve, reject) => {
    //get last sequence
    makeApiRequest({
      url: `${LOCATION_MEDIA_LAST_SEQUENCE_URL.url}/${locationId}`,
      method: LOCATION_MEDIA_LAST_SEQUENCE_URL.method
    })
      .then(response => {
        let lastSeq = response.data.sequence;
        const createMediaReq = [];
        medias.forEach(media => {
          lastSeq++;
          createMediaReq.push({
            data: {
              sequence: lastSeq,
              isCover: 0,
              caption: !!media.details ? media.details.caption || null : null,
              description: !!media.details
                ? media.details.description || null
                : null,
              status: media.uploadStatus //1 active, 6 error
            },
            media: {
              name: media.name,
              fileType: media.type,
              size: media.size,
              bucket: media.bucket,
              bucketOriginal: media.bucket,
              fileValue: media.key,
              extension: media.ext,
              isPublic: media.isPublic,
              isTemp: 0,
              tempToken: null,
              type: 4, // for location
              createdBy: createdBy,
              status: media.uploadStatus, //1 active, 6 error
              attribution:
                !!media.details &&
                  (!!media.details.attributionName ||
                    !!media.details.attributionUrl)
                  ? {
                    name: media.details.attributionName || null,
                    url: media.details.attributionUrl || null
                  }
                  : null
            }
          });
        });

        if (createMediaReq.length > 0) {
          makeApiRequest({
            url: `${LOCATION_MEDIA_CREATE_URL.url}/${locationId}`,
            method: LOCATION_MEDIA_CREATE_URL.method,
            data: createMediaReq
          })
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export default function MediaPanel({ parentId, medias }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const EDIT_ACCESS = checkAcl({ p: permissions.LOCATION_MANAGEMENT, t: types.VIEW_AND_EDIT });
  const DELETE_ACCESS = checkAcl({ p: permissions.LOCATION_MANAGEMENT, t: types.VIEW_EDIT_AND_DELETE });

  const [mediaList, setMediaList] = useState();
  const [uploadMedias, setUploadMedias] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stopSubmitting, setStopSubmitting] = useState(false);
  const [openMediaModal, setOpenMediaModal] = useState(false);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [openMediaEditModal, setOpenMediaEditModal] = useState(false);
  const [editMediaDetails, setEditMediaDetails] = useState(null);

  const createdBy = 1;
  const isPublic = 1;

  function handleOpenMediaEditModal() {
    setOpenMediaEditModal(true);
  }

  function handleCloseMediaEditModal() {
    setOpenMediaEditModal(false);
    setEditMediaDetails(null);
  }

  function handleOpenConfirmDialog() {
    setOpenConfirmDialog(true);
  }

  function handleCloseConfirmDialog() {
    setOpenConfirmDialog(false);
    setSelectedIndex(null);
  }

  function handleOpenMediaModal() {
    setOpenMediaModal(true);
  }

  function handleCloseMediaModal() {
    setOpenMediaModal(false);
  }

  function editMediaMenuClick(index) {
    const media = mediaList[index];
    setEditMediaDetails({
      id: media.locMediaId,
      caption: !!media.caption ? media.caption : "",
      isCover: media.isCover,
      status: media.status,
      description: !!media.description ? media.description : "",
      attributionName: !!media.attribution
        ? !!media.attribution.name
          ? media.attribution.name
          : ""
        : "",
      attributionUrl: !!media.attribution
        ? !!media.attribution.url
          ? media.attribution.url
          : ""
        : ""
    });
    handleOpenMediaEditModal();
  }

  async function editMediaCall(values) {
    setIsSubmitting(true);
    const reqJson = {
      isCover: values.isCover,
      caption: values.caption.trim().length > 0 ? values.caption.trim() : null,
      description:
        values.description.trim().length > 0 ? values.description.trim() : null,
      status: values.status,
      attribution:
        values.attributionName.trim().length > 0 ||
          values.attributionUrl.trim().length > 0
          ? {
            name:
              values.attributionName.trim().length > 0
                ? values.attributionName.trim()
                : null,
            url:
              values.attributionUrl.trim().length > 0
                ? values.attributionUrl.trim()
                : null
          }
          : null
    };

    await makeApiRequest({
      url: `${LOCATION_MEDIA_EDIT_URL.url}/${values.id}`,
      method: LOCATION_MEDIA_EDIT_URL.method,
      data: reqJson
    })
      .then(response => {
        handleCloseMediaEditModal();
        setEditMediaDetails(null);
        setMediaList(
          mediaList.filter(media => {
            return media.locMediaId === values.id
              ? ((media.caption = reqJson.caption),
                (media.description = reqJson.description),
                (media.attribution = { ...reqJson.attribution }))
              : media;
          })
        );

        dispatch(showSuccessAlert("Updated Successfully"));
      })
      .catch(error => {
        dispatch(
          showErrorAlert(
            "Media Edit Error : " +
            (!!error.response
              ? `${error.response.status}! - ${error.response.data.errorMessage}`
              : error.message)
          )
        );
      });

    setIsSubmitting(false);
  }

  function deleteMediaMenuClick(index) {
    setSelectedIndex(index);
    handleOpenConfirmDialog();
  }

  async function deleteMediaCall(index) {
    setIsSubmitting(true);
    let temp = [...mediaList];
    const locMediaId = mediaList[index].locMediaId;
    //console.log(index);
    await makeApiRequest({
      url: `${LOCATION_MEDIA_DELETE_URL.url}/${locMediaId}`,
      method: LOCATION_MEDIA_DELETE_URL.method
    })
      .then(response => {
        if (
          !!response.data.status &&
          response.data.status.toUpperCase() === "SUCCESS"
        ) {
          temp.splice(index, 1);
          setMediaList([...temp]);
          dispatch(showSuccessAlert("Media deleted successfully"));
        } else {
          dispatch(showErrorAlert("Something went wrong while deleting"));
        }
      })
      .catch(error => {
        dispatch(
          showErrorAlert(
            "Media Delete Error : " +
            (!!error.response
              ? `${error.response.status}! - ${error.response.data.errorMessage}`
              : error.message)
          )
        );
      });

    temp = undefined;
    handleCloseConfirmDialog();
    setIsSubmitting(false);
    setSelectedIndex(null);
  }

  async function swapMediaCall(index, direction) {
    setIsSubmitting(true);
    let temp = [...mediaList];

    let id0 = mediaList[index].locMediaId;
    let id1 = mediaList[index].locMediaId;

    if (direction === "right" && index + 1 < mediaList.length) {
      id1 = mediaList[index + 1].locMediaId;
      temp.splice(index, 0, temp.splice(index + 1, 1)[0]);
    } else if (direction === "left" && index > 0) {
      id1 = mediaList[index - 1].locMediaId;
      temp.splice(index - 1, 0, temp.splice(index, 1)[0]);
    }

    await makeApiRequest({
      url: `${LOCATION_MEDIA_SWAP_URL.url}/${parentId}`,
      method: LOCATION_MEDIA_SWAP_URL.method,
      data: {
        id0: id0,
        id1: id1
      }
    })
      .then(() => {
        setMediaList([...temp]);
      })
      .catch(error => {
        dispatch(
          showErrorAlert(
            "Media Swap Error : " +
            (!!error.response
              ? `${error.response.status}! - ${error.response.data.errorMessage}`
              : error.message)
          )
        );
      });

    temp = undefined;
    setIsSubmitting(false);
  }

  useEffect(() => {
    !!medias &&
      setMediaList([...medias.sort((a, b) => a.sequence > b.sequence)]);
  }, [medias]);

  useEffect(() => {
    if (uploadMedias.length > 0) {
      setStopSubmitting(false);
      createMediaCall(parentId, uploadMedias, createdBy)
        .then(() => {
          //axios call and update
          makeApiRequest({
            url: `${LOCATION_MEDIA_GET_LIST_URL.url}/${parentId}`,
            method: LOCATION_MEDIA_GET_LIST_URL.method
          })
            .then(response => {
              !!response.data &&
                setMediaList(
                  response.data.sort((a, b) => a.sequence > b.sequence)
                );
              dispatch(showSuccessAlert("Media(s) uploaded!!"));
              setOpenMediaModal(false);
              setStopSubmitting(true); //to enable the upload modal back.
            })
            .catch(error => {
              setOpenMediaModal(false);
              setStopSubmitting(true); //to enable the upload modal back.
              dispatch(
                showErrorAlert(
                  "Media List Fetch Error : " +
                  (!!error.response
                    ? `${error.response.status}! - ${error.response.data.errorMessage}`
                    : error.message)
                )
              );
            });
          setIsSubmitting(false);
        })
        .catch(error => {
          setStopSubmitting(true);
          setIsSubmitting(false);
          dispatch(
            showErrorAlert(
              "Error : " +
              (!!error.response
                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                : error.message)
            )
          );
        });
    }
  }, [uploadMedias, parentId, dispatch]);

  return (
    <Fragment>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="loc-media-content"
          id="loc-media-header"
        >
          <Typography className={classes.heading}>Media</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box component="span" display="inline" width="100%">
            {!!mediaList && mediaList.length > 0 ? (
              <Box
                display="flex"
                flexDirection="row"
                flexWrap="wrap"
                justifyContent="flex-start"
              >
                {mediaList.map((media, index) => {
                  return (
                    <MediaCard
                      key={media.mediaId}
                      media={media}
                      index={index}
                      totalMediaCount={mediaList.length}
                      editMediaMenuClick={editMediaMenuClick}
                      deleteMediaMenuClick={deleteMediaMenuClick}
                      swapMedia={swapMediaCall}
                      isSubmitting={isSubmitting}
                      editPermission={EDIT_ACCESS}
                      deletePermission={DELETE_ACCESS}
                    />
                  );
                })}
              </Box>
            ) : (
              <Box justifyContent="center" display="flex">
                No Media Records !!
              </Box>
            )}
            {EDIT_ACCESS &&
              <Box
                justifyContent="center"
                display="flex"
                style={{ marginTop: "15px" }}
              >
                <Fab
                  size="small"
                  color="primary"
                  aria-label="add"
                  onClick={handleOpenMediaModal}
                >
                  <AddIcon />
                </Fab>
              </Box>}
          </Box>
        </AccordionDetails>
      </Accordion>
      <UploadMediaModal
        openModal={openMediaModal}
        handleCloseModal={handleCloseMediaModal}
        // bucket={AWS_S3.location.bucket}
        isPublic={isPublic}
        setUploadMedias={setUploadMedias}
        stopSubmitting={stopSubmitting}
      />
      <ConfirmDialog
        openDialog={openConfirmDialog}
        handleCloseDialog={handleCloseConfirmDialog}
        title={"Delete Location Media"}
        message={"Are you sure you want to delete?"}
        buttonLabel={"Delete"}
        isSubmitting={isSubmitting}
        selectedIndex={selectedIndex}
        handleSubmit={deleteMediaCall}
      />
      <MediaEditForm
        openModal={openMediaEditModal}
        handleCloseModal={handleCloseMediaEditModal}
        mediaDetails={editMediaDetails}
        isSubmitting={isSubmitting}
        handleUpdate={editMediaCall}
      />
    </Fragment>
  );
}
